import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-row-actions',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="ia-row-actions" role="group" [attr.aria-label]="'Actions for ' + rowLabel">
      <ng-container *ngIf="!editing; else editActions">
        <button type="button" class="btn btn-default" [disabled]="disabled"
          [attr.aria-label]="'Edit ' + rowLabel" (click)="edit.emit()">Edit</button>
        <button type="button" class="btn btn-default ia-row-remove" [disabled]="disabled"
          [attr.aria-label]="'Remove ' + rowLabel" (click)="remove.emit()">Remove</button>
      </ng-container>
      <ng-template #editActions>
        <button type="button" class="btn btn-brand" [disabled]="disabled"
          [attr.aria-label]="'Save ' + rowLabel" (click)="save.emit()">Save</button>
        <button type="button" class="btn btn-default" [disabled]="disabled"
          [attr.aria-label]="'Cancel changes to ' + rowLabel" (click)="cancel.emit()">Cancel</button>
      </ng-template>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .ia-row-actions { display: flex; justify-content: flex-end; gap: 6px; }
    .ia-row-actions button { min-height: 40px; padding: 8px 10px; white-space: nowrap; }
    .ia-row-remove { color: var(--ia-danger); }
  `]
})
export class TableRowActionsComponent {
  @Input() editing = false;
  @Input() disabled = false;
  @Input() rowLabel = 'row';
  @Output() edit = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
